export enum BackgroundMusicMode {
  NONE = 0,
  AREA = 1,
  BATTLE = 2,
  BATTLE_STINGER = 3,
  DIALOG = 4
};